import { render, staticRenderFns } from "./WeekStarNew.vue?vue&type=template&id=764ff961&scoped=true"
import script from "./WeekStarNew.vue?vue&type=script&lang=js"
export * from "./WeekStarNew.vue?vue&type=script&lang=js"
import style0 from "./WeekStarNew.vue?vue&type=style&index=0&id=764ff961&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ff961",
  null
  
)

export default component.exports